const EquatorialGuineaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111373)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.1738 13.0435H38.7558C35.93 5.4275 28.5991 0 19.9999 0C14.4769 0 9.47746 2.23898 5.8584 5.85852L12.1738 13.0435Z"
        fill="#6DA544"
      />
      <path
        d="M12.1738 26.957H38.7558C35.93 34.573 28.5991 40.0005 19.9999 40.0005C14.4769 40.0005 9.47746 37.7616 5.8584 34.142L12.1738 26.957Z"
        fill="#D80027"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#0052B4"
      />
      <path
        d="M23.4785 16.5215V20.8693C23.4785 23.5318 26.9568 24.3477 26.9568 24.3477C26.9568 24.3477 30.4351 23.5318 30.4351 20.8693V16.5215H23.4785Z"
        fill="#DEDDE0"
      />
      <path d="M26.0864 20.0869H27.8256V22.6086H26.0864V20.0869Z" fill="#786145" />
      <path
        d="M28.6955 19.1307C28.6955 18.1702 27.9169 17.3916 26.9563 17.3916C25.9958 17.3916 25.2172 18.1702 25.2172 19.1307C24.737 19.1307 24.3477 19.52 24.3477 20.0003C24.3477 20.4805 24.737 20.8698 25.2172 20.8698H28.6955C29.1757 20.8698 29.565 20.4805 29.565 20.0003C29.565 19.52 29.1758 19.1307 28.6955 19.1307Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111373">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EquatorialGuineaSvg;
